import { Directive, ElementRef, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { fromEvent } from 'rxjs';
import { take } from 'rxjs/operators';

const idArray = ['dropdownItem', 'dropdownOption', 'removeBtn', 'removeImg', 'removeText'];

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[appClickOutside]'
})
export class ClickOutsideDirective implements OnInit{
  @Output() appClickOutside = new EventEmitter();

  captured = false;

  constructor(private elRef: ElementRef) { }

  @HostListener('document:click', ['$event.target'])
  onClick(target) {
    if (!this.captured) { return; }
    if (idArray.indexOf(target.id) >= 0) { return; }
    if (!this.elRef.nativeElement.contains(target)) {
      this.appClickOutside.emit();
    }
  }

  ngOnInit() {
    fromEvent(document, "click", { capture: true })
      .pipe(take(1))
      .subscribe(() => (this.captured = true));
  }
}
